export default __webpack_public_path__ + "4e5974cc26f6e7253ea83c6bb616dc14.svg";